import {
  getRememberEmailFromStorage,
  saveRememberEmailOnStorage,
} from '@features/auth/store/auth.storage';
import { Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';

export const RememberMeCheckbox: React.FC = () => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const rememberEmail = getRememberEmailFromStorage();
    setChecked(rememberEmail);
  }, []);

  const handleChange = (e: any) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    saveRememberEmailOnStorage(isChecked);
  };

  return (
    <Checkbox
      data-testid='remember-me'
      checked={checked}
      onChange={handleChange}
    >
      Lembrar e-mail
    </Checkbox>
  );
};
